import { usePage } from '@inertiajs/react';
import AppShell, { PageHeader, EmptyState } from '../../../components/layout/AppShell';

export default function StudentLiveSessionsIndex() {
  const auth = usePage().props.auth;

  return (
    <AppShell student={auth?.user} scrollTitle="Live Session">
      <PageHeader
        title="Live Session"
        subtitle="When your teacher invites you, you'll join the lobby from here."
      />
      <EmptyState
        title="No active session"
        description="Wait for your teacher to send you an invite. It'll appear automatically — no need to refresh."
      />
    </AppShell>
  );
}
